import React from 'react'
import { Typography } from '@mui/material'
import { UseFormRegister } from 'react-hook-form'
import ScanCode from '../../../components/ScanCode/ScanCode'
import TextLabel from '../../../components/TextLabel/TextLabel'
import UserGuidance from '../../../components/UserGuidance/UserGuidance'
import theme from 'src/styles/theme'
import * as S from '../DivergenceProductPage.styles'

interface AddressFormData {
  addressCode: string
}

interface AddressStepProps {
  divergenceActiveAddress: string | undefined
  onAddressSubmit: () => void
  registerAddress: UseFormRegister<AddressFormData>
  hasAddressError: boolean
}

const AddressStep: React.FC<AddressStepProps> = ({
  divergenceActiveAddress,
  onAddressSubmit,
  registerAddress,
  hasAddressError,
}) => (
  <>
    <S.Info>
      <S.ContainerProductName>
        <Typography style={{ fontWeight: 'bold', fontSize: '24px' }}>Endereço</Typography>
        <UserGuidance text='Dirija-se para:'>
          <TextLabel
            width='100%'
            height='3.2rem'
            backgroundColor={theme.colors.green4}
          >
            <Typography style={{ fontWeight: 'bold', fontSize: '24px' }}>
              {divergenceActiveAddress}
            </Typography>
          </TextLabel>
        </UserGuidance>
      </S.ContainerProductName>
    </S.Info>
    <S.Form>
      <ScanCode
        text='Ao chegar bipe o código do endereço.'
        onSubmit={onAddressSubmit}
        register={registerAddress}
        dataTestId='input-address-code-test-id'
        inputName='addressCode'
        hasError={hasAddressError}
        errorMessage='Endereço incorreto!'
      />
    </S.Form>
  </>
)

export default AddressStep
